module.exports = __webpack_public_path__ + "static/media/icnServIdentidad.aa608563.png";